export default {
    title: "Histórico de importações",
    subtitle: "Acompanhe as importações de pedidos e clientes do seu estabelecimento.",
    cancelConfirmTitle: "Cancelar importação?",
    cancelConfirmBody: "A importação será interrompida. Os itens já processados serão mantidos.",
    detailsTitle: "Detalhes da importação",
    close: "Fechar",
    details: "Detalhes",
    cancel: "Cancelar",
    preparing: "Preparando...",
    downloadFailed: "Baixar linhas com erro",
    columnType: "Tipo",
    columnFilename: "Arquivo",
    columnUser: "Usuário",
    columnBranch: "Unidade",
    columnStatus: "Status",
    columnProgress: "Progresso",
    columnResults: "Resultados",
    columnDate: "Data",
    columnActions: "Ações",
    columnError: "Erro",
    columnPlugin: "Integração",
    columnImporter: "Importador",
    noData: "Sem dados calculados",
    summaryNewOrders: "Novos pedidos",
    summaryUpdatedOrders: "Pedidos atualizados",
    summaryNewClients: "Novos clientes",
    summaryUpdatedClients: "Clientes atualizados",
    summaryImportedOrders: "Pedidos importados",
    summaryFailed: "Linhas com erro",
    filterType: "Tipo",
    filterStatus: "Status",
    filterPeriod: "Período",
    filterDateFrom: "De",
    filterDateTo: "Até",
    filterAll: "Todos",
    typeOrders: "Pedidos (planilha)",
    typeClients: "Clientes (planilha)",
    typePluginFile: "Arquivo de integração",
    typePluginHistory: "Histórico da integração",
    ordersShort: "Pedidos",
    clientsShort: "Clientes",
    failedShort: "Erros",
    cancelSuccess: "Importação cancelada",
    cancelError: "Erro ao cancelar importação",
    importData: "Importar dados",
    chooserTitle: "Importar dados",
    chooserSubtitle: "Escolha o que deseja importar.",
    newOrders: "Importar CSV de vendas",
    newClients: "Importar CSV de clientes",
    backfillButton: "Importar histórico {0}",
    backfillTitle: "Importar histórico",
    backfillSubtitle: "Escolha o período dos pedidos que deseja importar da integração.",
    backfillStart: "Iniciar importação",
    backfillStarted: "Importação de histórico iniciada! Ela será processada em segundo plano.",
    backfillError: "Não foi possível iniciar a importação de histórico.",
    queuedNotice: "Importação enviada! Ela será processada em segundo plano.",
};
